<p>
  auth-sing works!
</p>
